import React from "react";
import { Field, Input } from "@fluentui/react-components";

const InputField = ({ type, name, label, value, error, onChange }) => (
  <Field label={label} validationState={error ? "error" : "none"} validationMessage={error}>
    <Input type={type} value={value} onChange={(e) => onChange(name, e.target.value)} />
  </Field>
);

export default InputField;
